// React markdown takes in markdown as a `children` prop
/* eslint-disable react/no-children-prop */

import ReactMarkdown from 'react-markdown';
import {ReactMarkdownProps, UnorderedListProps} from 'react-markdown/lib/ast-to-react';
import cx from 'classnames';
import remarkBreaks from 'remark-breaks';
import remarkGfm from 'remark-gfm';

import {Anchor} from './component/Anchor';
import {Blockquote} from './component/Blockquote';
import {Heading1} from './component/Heading1';
import {Heading2} from './component/Heading2';
import {Heading3} from './component/Heading3';
import {Image} from './component/Image';
import {ListItem} from './component/ListItem';
import {OrderedList} from './component/OrderedList';
import {Paragraph} from './component/Paragraph';
import {Table} from './component/Table';
import {TableCell} from './component/TableCell';
import {TableHeader} from './component/TableHeader';
import {TableRow} from './component/TableRow';
import {UnorderedList} from './component/UnorderedList';

import {MarkdownProps} from './Markdown.types';

import {excerpt, list, listItem, markdownStyle, paragraph} from './Markdown.css';

export const Markdown = ({data, className, components = {}}: MarkdownProps) => {
  return (
    <ReactMarkdown
      className={cx(markdownStyle, className)}
      children={data}
      remarkPlugins={[remarkGfm, remarkBreaks]}
      components={{
        a: Anchor,
        blockquote: Blockquote,
        h1: Heading1,
        h2: Heading2,
        h3: Heading3,
        img: Image,
        li: (props: ReactMarkdownProps) => <ListItem className={listItem} {...props} />,
        ol: OrderedList,
        p: (props: ReactMarkdownProps) => (
          <Paragraph className={paragraph} excerptProps={{className: excerpt}} {...props} />
        ),
        table: Table,
        td: TableCell,
        th: TableHeader,
        tr: TableRow,
        ul: (props: UnorderedListProps) => <UnorderedList className={list} {...props} />,
        ...components,
      }}
    />
  );
};
